module.exports = __webpack_public_path__ + "static/media/odex_logo_black.82ca9fa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/odex_logo_black.png
// module id = 565
// module chunks = 0